export const currentColumn = [
  {
    label: "Name",
    field: "shareholde_name"
  },
  {
    label: "Country/Region",
    field: "shareholde_country"
  },
  {
    label: "Type",
    field: "shareholde_type"
  },
  // {
  //   label: "Direct %",
  //   field: "d"
  // },
  {
    label: "Total %",
    field: "total_per"
  },
  {
    label: "Date",
    field: "date"
  }
]

export const shareholderColumn = [
  {
    label: "Name",
    field: "shareholde_name"
  },
  {
    label: "Country/Region",
    field: "shareholde_country"
  },
  {
    label: "Type",
    field: "shareholde_type"
  },
  // {
  //   label: "Direct %",
  //   field: "d"
  // },
  {
    label: "Total %",
    field: "total_per"
  },
  {
    label: "Date",
    field: "date"
  }
]

export const subsidiaryColumn = [
  {
    label: "Name",
    field: "a"
  },
  {
    label: "Country/Region",
    field: "b"
  },
  {
    label: "Type",
    field: "c"
  },
  // {
  //   label: "Direct %",
  //   field: "d"
  // },
  {
    label: "Total %",
    field: "e"
  },
  {
    label: "Date",
    field: "f"
  },
  {
    label: "No of employees",
    field: "g"
  }
]

export const branchesColumn = [
  {
    label: "Name",
    field: "a"
  },
  {
    label: "Country/Region",
    field: "a"
  },
  {
    label: "City",
    field: "a"
  }
]